'use client'

import { useAuthContext } from '@/contexts/AuthContext'
import { roboto } from '@/lib/fonts'
import { Language } from '@/lib/interfaces/interfaces'
import { faEdit } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Link from 'next/link'
import { useEffect, useState } from 'react'

interface Props{
	barEmail: string
  language: Language
}

const EditMenuButton = ({ barEmail, language } : Props) => {
  const { user } = useAuthContext()

  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    if (user?.email === barEmail) {
      setShowButton(true)
    }
  }, [barEmail, user?.email])

  if (showButton) {
    return (
      <div className='edit-menu-button'>
        <Link style={roboto.style} href='/dashboard/digital-menu'>
          <FontAwesomeIcon icon={faEdit} /> {language === 'es' ? 'EDITAR' : 'EDIT'}
        </Link>
      </div>
    )
  } else {
    return null
  }
}
export default EditMenuButton
